const bridgeCategoriesTree = [
  {
    id: 161,
    name: "Logement",
    categories: [
      {
        id: 216,
        name: "Loyer",
      },
      {
        id: 217,
        name: "Electricité",
      },
      {
        id: 218,
        name: "Gaz",
      },
      {
        id: 220,
        name: "Logement - Autres",
      },
      {
        id: 221,
        name: "Décoration",
      },
      {
        id: 222,
        name: "Entretien",
      },
      {
        id: 246,
        name: "Assurance habitation",
      },
      {
        id: 293,
        name: "Eau",
      },
      {
        id: 323,
        name: "Extérieur et jardin",
      },
      {
        id: 328,
        name: "Charges diverses",
      },
    ],
  },
  {
    id: 166,
    name: "Dépenses pro",
    categories: [
      {
        id: 90,
        name: "Dépenses pro - Autres",
      },
      {
        id: 202,
        name: "Publicité",
      },
      {
        id: 203,
        name: "Maintenance bureaux",
      },
      {
        id: 204,
        name: "Frais d'expéditions",
      },
      {
        id: 205,
        name: "Frais d'impressions",
      },
      {
        id: 265,
        name: "Notes de frais",
      },
      {
        id: 270,
        name: "Services en ligne",
      },
      {
        id: 274,
        name: "Fournitures de bureau",
      },
      {
        id: 441886,
        name: "Cotisations Sociales",
      },
      {
        id: 441889,
        name: "Comptabilité",
      },
      {
        id: 441890,
        name: "Salaires",
      },
      {
        id: 441891,
        name: "Rémunérations dirigeants",
      },
      {
        id: 441892,
        name: "Frais de recrutement",
      },
      {
        id: 441895,
        name: "Conseils",
      },
      {
        id: 441896,
        name: "Sous-traitance",
      },
      {
        id: 441897,
        name: "Prévoyance",
      },
      {
        id: 441898,
        name: "Taxe d'apprentissage",
      },
      {
        id: 441899,
        name: "Frais juridique",
      },
      {
        id: 441900,
        name: "Marketing",
      },
    ],
  },
  {
    id: 160,
    name: "Divers",
    categories: [
      {
        id: 1,
        name: "A catégoriser",
      },
      {
        id: 276,
        name: "Autres dépenses",
      },
      {
        id: 278,
        name: "Assurance",
      },
      {
        id: 294,
        name: "Dons",
      },
      {
        id: 308,
        name: "Tabac",
      },
      {
        id: 324,
        name: "Pressing",
      },
    ],
  },
  {
    id: 170,
    name: "Loisirs & Sorties",
    categories: [
      {
        id: 223,
        name: "Loisirs & Sorties - Autres",
      },
      {
        id: 224,
        name: "Frais Animaux",
      },
      {
        id: 226,
        name: "Hobbies",
      },
      {
        id: 227,
        name: "Bars / Clubs",
      },
      {
        id: 242,
        name: "Sport",
      },
      {
        id: 244,
        name: "Sorties culturelles",
      },
      {
        id: 249,
        name: "Voyages / Vacances",
      },
      {
        id: 263,
        name: "Hôtels",
      },
      {
        id: 269,
        name: "Divertissements",
      },
      {
        id: 310,
        name: "Sports d'hiver",
      },
      {
        id: 320,
        name: "Sortie au restaurant",
      },
    ],
  },
  {
    id: 162,
    name: "Achats & Shopping",
    categories: [
      {
        id: 183,
        name: "Cadeaux",
      },
      {
        id: 184,
        name: "High Tech",
      },
      {
        id: 186,
        name: "Achats & Shopping - Autres",
      },
      {
        id: 243,
        name: "Livres",
      },
      {
        id: 262,
        name: "Articles de sport",
      },
      {
        id: 272,
        name: "Vêtements/Chaussures",
      },
      {
        id: 318,
        name: "Musique",
      },
      {
        id: 319,
        name: "Films & DVDs",
      },
      {
        id: 441888,
        name: "Licences",
      },
    ],
  },
  {
    id: 159,
    name: "Impôts & Taxes",
    categories: [
      {
        id: 206,
        name: "Impôts & Taxes - Autres",
      },
      {
        id: 207,
        name: "Amendes",
      },
      {
        id: 208,
        name: "Impôts sur le revenu",
      },
      {
        id: 209,
        name: "Impôts fonciers",
      },
      {
        id: 302,
        name: "Taxes",
      },
      {
        id: 441988,
        name: "TVA",
      },
    ],
  },
  {
    id: 171,
    name: "Abonnements",
    categories: [
      {
        id: 180,
        name: "Internet",
      },
      {
        id: 219,
        name: "Câble / Satellite",
      },
      {
        id: 258,
        name: "Téléphonie fixe",
      },
      {
        id: 277,
        name: "Téléphonie mobile",
      },
      {
        id: 280,
        name: "Abonnements - Autres",
      },
    ],
  },
  {
    id: 315,
    name: "Esthétique & Soins",
    categories: [
      {
        id: 235,
        name: "Coiffeur",
      },
      {
        id: 248,
        name: "Cosmétique",
      },
      {
        id: 316,
        name: "Spa & Massage",
      },
      {
        id: 317,
        name: "Esthétique & Soins - Autres",
      },
      {
        id: 321,
        name: "Esthétique",
      },
    ],
  },
  {
    id: 164,
    name: "Banque",
    categories: [
      {
        id: 79,
        name: "Frais bancaires",
      },
      {
        id: 89,
        name: "Remboursement emprunt",
      },
      {
        id: 191,
        name: "Débit mensuel carte",
      },
      {
        id: 192,
        name: "Epargne",
      },
      {
        id: 194,
        name: "Hypothèque",
      },
      {
        id: 195,
        name: "Banque - Autres",
      },
      {
        id: 306,
        name: "Services Bancaires",
      },
      {
        id: 756587,
        name: "Incidents de paiement",
      },
    ],
  },
  {
    id: 163,
    name: "Santé",
    categories: [
      {
        id: 236,
        name: "Pharmacie",
      },
      {
        id: 245,
        name: "Mutuelle",
      },
      {
        id: 261,
        name: "Médecin",
      },
      {
        id: 268,
        name: "Santé - Autres",
      },
      {
        id: 322,
        name: "Opticien / Ophtalmo.",
      },
      {
        id: 325,
        name: "Dentiste",
      },
    ],
  },
  {
    id: 167,
    name: "Scolarité & Enfants",
    categories: [
      {
        id: 237,
        name: "Scolarité & Enfants - Autres",
      },
      {
        id: 238,
        name: "Fournitures scolaires",
      },
      {
        id: 239,
        name: "Ecole",
      },
      {
        id: 240,
        name: "Pensions",
      },
      {
        id: 241,
        name: "Logement étudiant",
      },
      {
        id: 259,
        name: "Prêt étudiant",
      },
      {
        id: 266,
        name: "Jouets",
      },
      {
        id: 267,
        name: "Baby-sitters & Crèches",
      },
    ],
  },
  {
    id: 165,
    name: "Auto & Transports",
    categories: [
      {
        id: 84,
        name: "Auto & Transports - Autres",
      },
      {
        id: 87,
        name: "Carburant",
      },
      {
        id: 196,
        name: "Transports en commun",
      },
      {
        id: 197,
        name: "Billets de train",
      },
      {
        id: 198,
        name: "Billets d'avion",
      },
      {
        id: 247,
        name: "Assurance véhicule",
      },
      {
        id: 251,
        name: "Stationnement",
      },
      {
        id: 264,
        name: "Location de véhicule",
      },
      {
        id: 288,
        name: "Entretien véhicule",
      },
      {
        id: 309,
        name: "Péage",
      },
    ],
  },
  {
    id: 2,
    name: "Entrées d'argent",
    categories: [
      {
        id: 3,
        name: "Autres rentrées",
      },
      {
        id: 80,
        name: "Intérêts",
      },
      {
        id: 230,
        name: "Salaires",
      },
      {
        id: 231,
        name: "Ventes",
      },
      {
        id: 232,
        name: "Services",
      },
      {
        id: 233,
        name: "Extra",
      },
      {
        id: 271,
        name: "Dépôt d'argent",
      },
      {
        id: 279,
        name: "Retraite",
      },
      {
        id: 282,
        name: "Virements internes",
      },
      {
        id: 283,
        name: "Remboursements",
      },
      {
        id: 289,
        name: "Economies",
      },
      {
        id: 314,
        name: "Loyers reçus",
      },
      {
        id: 327,
        name: "Allocations et pensions",
      },
      {
        id: 441893,
        name: "Subventions",
      },
      {
        id: 441894,
        name: "Emprunt",
      },
    ],
  },
  {
    id: 168,
    name: "Alimentation & Restau.",
    categories: [
      {
        id: 83,
        name: "Restaurants",
      },
      {
        id: 188,
        name: "Alimentation - Autres",
      },
      {
        id: 260,
        name: "Fast foods",
      },
      {
        id: 273,
        name: "Supermarché / Epicerie",
      },
      {
        id: 313,
        name: "Café",
      },
    ],
  },
  {
    id: 303,
    name: "Retraits, Chq. et Vir.",
    categories: [
      {
        id: 78,
        name: "Virements",
      },
      {
        id: 85,
        name: "Retraits",
      },
      {
        id: 88,
        name: "Chèques",
      },
      {
        id: 326,
        name: "Virements internes",
      },
    ],
  },
] as const;

export const extraCategories = [
  { id: "works", name: "Travaux" },
  { id: "incomes", name: "Entrées d'argent" },
  { id: "interests", name: "Intérêts" },
  { id: "taxes", name: "Impôt et taxes" },
  { id: "subscribtions", name: "Abonnements" },
  { id: "operational", name: "Charges opérationelles" },
  { id: "other_expenses", name: "Frais divers" },
  { id: "energy", name: "Energie" },
  { id: "ca", name: "Chiffre d'affaires" },
  { id: "management_fee", name: "Honoraire de gestion" },
] as const;

type ExtraCategoryIds = (typeof extraCategories)[number]["id"];

export const bridgeCategories = bridgeCategoriesTree.flatMap((e) =>
  e.categories.map((c) => ({ id: c.id, name: c.name })),
);

export type BridgeCategoryIds = (typeof bridgeCategories)[number]["id"];

export const overridedCategories = {
  3: "incomes",
  80: "incomes",
  230: "incomes",
  231: "incomes",
  232: "incomes",
  233: "incomes",
  271: "incomes",
  279: "incomes",
  282: "incomes",
  283: "incomes",
  289: "incomes",
  314: "incomes",
  327: "incomes",
  441893: "incomes",
  206: "taxes",
  207: "taxes",
  208: "taxes",
  209: "taxes",
  302: "taxes",
  441988: "taxes",
  276: "other_expenses",
  294: "other_expenses",
  308: "other_expenses",
  324: "other_expenses",
  278: "operational",
  217: "energy",
  218: "energy",
  293: "energy",
  220: 216,
  221: "works",
  222: "operational",
  246: "operational",
  323: "other_expenses",
  328: "other_expenses",
  183: "other_expenses",
  184: "other_expenses",
  186: "other_expenses",
  243: "other_expenses",
  262: "other_expenses",
  272: "other_expenses",
  318: "other_expenses",
  319: "other_expenses",
  441888: "other_expenses",
  236: "other_expenses",
  245: "other_expenses",
  261: "other_expenses",
  268: "other_expenses",
  322: "other_expenses",
  325: "other_expenses",
  84: "other_expenses",
  87: "other_expenses",
  196: "other_expenses",
  197: "other_expenses",
  198: "other_expenses",
  247: "other_expenses",
  251: "other_expenses",
  264: "other_expenses",
  288: "other_expenses",
  309: "other_expenses",
  90: "other_expenses",
  202: "other_expenses",
  203: "other_expenses",
  204: "other_expenses",
  205: "other_expenses",
  265: "other_expenses",
  270: "other_expenses",
  274: "other_expenses",
  237: "other_expenses",
  238: "other_expenses",
  239: "other_expenses",
  240: "other_expenses",
  241: "other_expenses",
  259: "other_expenses",
  266: "other_expenses",
  267: "other_expenses",
  83: "other_expenses",
  188: "other_expenses",
  260: "other_expenses",
  273: "other_expenses",
  313: "other_expenses",
  223: "other_expenses",
  224: "other_expenses",
  226: "other_expenses",
  227: "other_expenses",
  242: "other_expenses",
  244: "other_expenses",
  249: "other_expenses",
  263: "other_expenses",
  269: "other_expenses",
  310: "other_expenses",
  320: "other_expenses",
  235: "other_expenses",
  248: "other_expenses",
  316: "other_expenses",
  317: "other_expenses",
  321: "other_expenses",
  441886: 441890,
  441891: 441890,
  441889: "operational",
  441892: "operational",
  441895: "operational",
  441896: "operational",
  441897: "operational",
  441899: "operational",
  441900: "operational",
  441898: "taxes",
  180: "subscribtions",
  219: "subscribtions",
  258: "subscribtions",
  277: "subscribtions",
  280: "subscribtions",
  78: 1,
  85: 1,
  88: 1,
  326: 1,
  191: 79,
  192: 79,
  194: 79,
  195: 79,
  306: 79,
  756587: 79,
} as const satisfies Partial<Record<BridgeCategoryIds, ExtraCategoryIds | BridgeCategoryIds>>;

type OverridedCategoriesId = keyof typeof overridedCategories;

type BridgeCategoriesToKeep = Exclude<BridgeCategoryIds, OverridedCategoriesId>;

const bridgeCategoriesToKeep: BridgeCategoriesToKeep[] = [216, 441890, 1, 79, 89, 441894];

export const categories: { id: string; name: string }[] = [
  ...bridgeCategoriesToKeep.map((id) => {
    const c = bridgeCategories.find((c) => c.id === id);
    if (!c) throw new Error(`Category with id ${id} not found`);
    return { id: c.id.toString(), name: c.name };
  }),
  ...extraCategories,
].sort((a, b) => a.name.localeCompare(b.name));

export const isBridgeCategoryId = (id: string) => categories.some((c) => c.id === id);

export const mapBridgeCategoryId = (categoryId: number) => {
  const mappedId = overridedCategories[categoryId as keyof typeof overridedCategories] as
    string | number | undefined;
  return (mappedId ?? categoryId).toString();
};
